<template>
  <div id="app">
   <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'App',
  created () {
    this._init_sensors()
  },
  methods: {
    _init_sensors () {
      // 引入神策
      var sensors = require('sa-sdk-javascript')
      sensors.init({
        server_url: 'https://sensorsdata.xunyou.mobi/sa' + (['test-', 'localhost'].some(cur => { return location.hostname.includes(cur) }) ? '' : '?project=production'),
        is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time: true,
        send_type: 'beacon',
        heatmap: {
          // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
          clickmap: 'default',
          // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
          scroll_notice_map: 'not_collect'
        },
        show_log: false // 控制台不展示上报
      })
      sensors.quick('autoTrack') // 用于采集 $pageview 事件。
      Vue.prototype.$sensors = sensors
    }
  }
}
</script>

<style>
* {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
img {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* 标准语法 */
}
</style>
